export const firebase = {
  apiKey: "AIzaSyCq8xxtYKHn6kWXCEEfDk3fYpHM4_3OCAg",
  authDomain: "mer-connect-prod.firebaseapp.com",
  projectId: "mer-connect-prod",
  storageBucket: "mer-connect-prod.appspot.com",
  messagingSenderId: "1006598539373",
  appId: "1:1006598539373:web:b738cffec7538714a99764",
  measurementId: "G-DLT2KF3TRG"
};

console.log('prod env');

// PROD
export const firebaseHub = {
  apiKey: "AIzaSyAUMlp99vgZv4DR64enoCYB7WiWdUAWuGs",
  authDomain: "merhub-test-999e1.firebaseapp.com",
  projectId: "merhub-test-999e1",
  storageBucket: "merhub-test-999e1.firebasestorage.app",
  messagingSenderId: "915602409554",
  appId: "1:915602409554:web:ea95c949c9e27963c1b78b",
  measurementId: "G-K61SJZC91T"
};


export const environment = {
  production: true,
  bffBaseUrl: "https://api.cor.mer.eco/cor-mer-connect-bff/v1/",
  merBaseUrl: "https://api.cor.mer.eco/",
  msal: {
    AUTHORITY: "https://login.microsoftonline.com/5a6741a5-c5f9-4f82-90ed-c23747406f0a/v2.0",
    CLIENT_ID: "MER_CONNECT_ADMIN_PORTAL_CLIENT_ID",
    KNOWN_AUTHORITIES: ["identity.mer.eco"],
    REDIRECT_URL: "https://admin.connect.mer.eco/",
    // REDIRECT_URL: "https://mer-connect-prod.web.app/",
    SCOPES: ["MER_CONNECT_ADMIN_PORTAL_SCOPE"],

  }
};
